export default {
    title: "Hello Word",
}
